import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Card, Checkbox, CssBaseline } from '@mui/joy';
import TextInput from '../Components/TextInput';
import { extendTheme, ThemeProvider } from '@mui/joy'; // Import from @mui/joy
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons'; // Import the icons you need
import '@fontsource/montserrat'; // Import Poppins font
import EBNLogo from '../Images/LogoEBNLogin.png';
import coverOrange from '../Images/CoverOrange.png';
import slider1 from '../Images/slider1.png';
import axios from 'axios';
import SliderComponent from '../Components/SliderComponent';
import { API } from '../API/api';
import { useAuth } from '../Context/AuthContext';
import ButtonAttributeJOY from '../Components/ButtonAttributeJOY';
import { CircularProgress } from '@mui/material';
// Create the custom theme with the Poppins font family
const theme = extendTheme({
  typography: {
    fontFamily: 'Montserrat, sans-serif', // Apply Montserrat font family globally
  },

});



export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({
    error: false,
    message: '',
    status: 0
  });
  const [loading, setLoading] = useState(false);

  const { login } = useAuth(); // Access login function from AuthContext
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Active le chargement

    axios.post(`${API}/login`, { email, password })
      .then(response => {
        const newAuthState = {
          isAuthenticated: true,
          token: response.data.token,
          user: response.data.user,
          expiresAt: response.data.expires_at,
          role: response.data.role,
          permissions: []
        };

        login(newAuthState.user, newAuthState.token, newAuthState.expiresAt, newAuthState.role);
      })
      .catch(error => {
        console.error('Login error:', error);
        setErrors({
          error: true,
          message: error.response?.data?.message || 'An error occurred during login',
          status: error.response?.status || 500,
        });
      })
      .finally(() => {
        setLoading(false); // Désactive le chargement
      });
  };



  useEffect(() => {
    
  }, []);
  return (
    <ThemeProvider theme={theme}> {/* Apply the custom theme with Poppins font */}
      <Grid
        container
        spacing={0}
        sx={{

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '120vh',
        }}
      >

        <Grid item xs={12} md={6} lg={6} sx={{
          display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center', height: '125vh',
          backgroundImage: `url(${coverOrange})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '20px'
        }}>
          <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center' }}>
            <CssBaseline />
            <SliderComponent images={[slider1, slider1, slider1]} />
            <Typography variant="h4" component={'p'} align="center" sx={{ marginTop: 2, fontSize: '18px', color: '#ffffff' }}>
              Tableau de bord polyvalent personnalisable
            </Typography>
            <Typography variant="h6" component={'p'} align="center" sx={{ marginTop: 1, fontSize: '15px', color: '#ffffff' }}>
              Tout ce dont vous avez besoin dans un tableau de bord facilement personnalisable.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
          <Card sx={{ backgroundColor: 'white', width: '100%', maxWidth: { xs: '100%', sm: 400, md: 500 }, border: 'none', }}>
            <Box
              component="img"
              src={EBNLogo}
              sx={{ width: { xs: 200, md: 200 }, height: 'auto', margin: '0 auto', display: 'block' }}
            />
            <Typography variant="h1" component={'h1'} align="center" sx={{ fontSize: '29px', color: '#1D3E62' }}>
              Connectez-vous à votre compte
            </Typography>
            <Typography variant="h2" align="center" sx={{ marginBottom: 2 }}>
              Bienvenue à nouveau ! Veuillez saisir vos coordonnées
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
              {/* Email Input */}
              <TextInput
                label="Email"
                type="email"
                value={email}
                setValue={setEmail}
                icon={<FontAwesomeIcon icon={faUser} />} // User Icon for Email
              />
              {/* Password Input */}
              <TextInput
                label="Mot de passe"
                type="password"
                value={password}
                setValue={setPassword}
                icon={<FontAwesomeIcon icon={faLock} />} // Lock Icon for Password
              />

              {/* Remember Me Checkbox */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: 2 }}>
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  sx={{
                    fontSize: '12px',
                    color: '#1D3E62',

                  }}
                  size="sm"
                  label="En vous connectant, vous acceptez les Conditions générales et notre Politique de confidentialité."



                />

              </Box>


              {errors.error ? <Typography variant="h6" component={'span'} sx={{ textAlign: 'center', fontSize: '12px', color: 'red', margin: 2 }}>
                {errors.message}
              </Typography> : null}
              {/* Login Button  */}
              <ButtonAttributeJOY
                type="submit"
                Bgcolor="#1D3E62"
                color="white"
                bgColorHover="#1a324dde"
                ColorHover="#FFFFFF"
                Label={loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Se connecter"}
                height={'56px'}
                hidden={false}
              />

              {/* Forgot Password Link */}

            </Box>
          </Card>
        </Grid>


      </Grid>
    </ThemeProvider>
  );
}
